import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions =  {}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
};

export type Category = {
  __typename?: 'Category';
  alias: Scalars['String'];
  contents: Array<Content>;
  id: Scalars['ID'];
  localizations?: Maybe<Array<I18nCategory>>;
  name: Scalars['String'];
  params: Array<MetaContentParam>;
  priority: Scalars['Int'];
  tags?: Maybe<Array<Tag>>;
  totalContent: Scalars['Int'];
  totalContents: Scalars['Int'];
  type: Scalars['String'];
};


export type CategoryContentsArgs = {
  filter?: Maybe<ContentFilter>;
  library?: Maybe<LibraryFilter>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  paramFilters?: Maybe<ParamFilters>;
  sort?: Maybe<SortByParam>;
  tagID?: Maybe<Scalars['ID']>;
};


export type CategoryLocalizationsArgs = {
  lang: Array<Scalars['String']>;
};


export type CategoryParamsArgs = {
  name: Scalars['String'];
};


export type CategoryTotalContentsArgs = {
  filter?: Maybe<ContentFilter>;
  library?: Maybe<LibraryFilter>;
  paramFilters?: Maybe<ParamFilters>;
  sort?: Maybe<SortByParam>;
  tagID?: Maybe<Scalars['ID']>;
};

export type ComplexParam = {
  __typename?: 'ComplexParam';
  number?: Maybe<Scalars['Int']>;
  numbers?: Maybe<Array<Scalars['Int']>>;
  string?: Maybe<Scalars['String']>;
  strings?: Maybe<Array<Scalars['String']>>;
  type: Scalars['String'];
};

export type Content = {
  __typename?: 'Content';
  categories: Array<Category>;
  category: Category;
  description?: Maybe<Scalars['String']>;
  fileExt: Scalars['String'];
  id: Scalars['ID'];
  isInLibrary: Scalars['Boolean'];
  like: Like;
  link: Scalars['String'];
  listeningPosition: Scalars['Float'];
  localizations?: Maybe<Array<I18nContent>>;
  metaContentParams?: Maybe<Array<MetaContentParam>>;
  myRating?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  previews?: Maybe<Array<Preview>>;
  priority: Scalars['Int'];
  protected: Scalars['Boolean'];
  rating?: Maybe<Scalars['Float']>;
  readingPosition: Scalars['Float'];
  relations: Array<Content>;
  tags?: Maybe<Array<Tag>>;
  totalRelations: Scalars['Int'];
  type: Scalars['String'];
  view: View;
};


export type ContentIsInLibraryArgs = {
  type: LibraryType;
};


export type ContentLocalizationsArgs = {
  lang: Array<Scalars['String']>;
};


export type ContentRelationsArgs = {
  categoryID?: Maybe<Scalars['ID']>;
};


export type ContentTotalRelationsArgs = {
  categoryID?: Maybe<Scalars['ID']>;
};

export type ContentFilter = {
  typeName?: Maybe<Scalars['String']>;
};

export type I18nCategory = {
  __typename?: 'I18nCategory';
  id: Scalars['ID'];
  lang: Scalars['String'];
  name: Scalars['String'];
};

export type I18nContent = {
  __typename?: 'I18nContent';
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lang: Scalars['String'];
  link: Scalars['String'];
  name: Scalars['String'];
};

export type I18nMetaContentParam = {
  __typename?: 'I18nMetaContentParam';
  id: Scalars['ID'];
  lang: Scalars['String'];
  value: Scalars['String'];
};

export type I18nTag = {
  __typename?: 'I18nTag';
  displayName: Scalars['String'];
  id: Scalars['ID'];
  lang: Scalars['String'];
};

export type LibraryFilter = {
  logicOperator: LogicOperator;
  negative: Scalars['Boolean'];
  values: Array<LibraryType>;
};

export enum LibraryType {
  Readed = 'READED',
  ReadNow = 'READ_NOW',
  Top = 'TOP'
}

export type Like = {
  __typename?: 'Like';
  id: Scalars['ID'];
  isLiked: Scalars['Boolean'];
  total: Scalars['Int'];
};

export enum LogicOperator {
  And = 'and',
  Or = 'or'
}

export type MetaContentParam = Param & {
  __typename?: 'MetaContentParam';
  complex?: Maybe<ComplexParam>;
  id: Scalars['ID'];
  localizations?: Maybe<Array<I18nMetaContentParam>>;
  name: Scalars['String'];
  value: Scalars['String'];
};


export type MetaContentParamLocalizationsArgs = {
  lang: Array<Scalars['String']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  addToLibrary?: Maybe<Content>;
  deactivateSubs?: Maybe<Scalars['Boolean']>;
  like: Like;
  listeningPosition?: Maybe<Content>;
  rating?: Maybe<Content>;
  readingPosition?: Maybe<Content>;
  removeFromLibrary?: Maybe<Content>;
  view: View;
};


export type MutationAddToLibraryArgs = {
  id: Scalars['ID'];
  type: LibraryType;
};


export type MutationLikeArgs = {
  id: Scalars['ID'];
};


export type MutationListeningPositionArgs = {
  id: Scalars['ID'];
  position: Scalars['Float'];
};


export type MutationRatingArgs = {
  id: Scalars['ID'];
  rate: Scalars['Int'];
};


export type MutationReadingPositionArgs = {
  id: Scalars['ID'];
  position: Scalars['Float'];
};


export type MutationRemoveFromLibraryArgs = {
  id: Scalars['ID'];
  type: LibraryType;
};


export type MutationViewArgs = {
  id: Scalars['ID'];
};

export enum Order {
  Asc = 'asc',
  Desc = 'desc',
  Rand = 'rand'
}

export type Param = {
  id: Scalars['ID'];
  name: Scalars['String'];
  /** Base64 encoded JSON object */
  value: Scalars['String'];
};

export type ParamFilter = {
  paramName: Scalars['String'];
  value?: Maybe<Array<Scalars['String']>>;
};

export type ParamFilters = {
  logicOperator: LogicOperator;
  negative: Scalars['Boolean'];
  params?: Maybe<Array<Maybe<ParamFilter>>>;
};

export type Point = {
  __typename?: 'Point';
  flowURL?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  service: Service;
  sid: Scalars['String'];
  sskey: Scalars['String'];
  tariff: Scalars['Int'];
  verify?: Maybe<Scalars['Boolean']>;
};

export type Preview = {
  __typename?: 'Preview';
  ext: Scalars['String'];
  id: Scalars['ID'];
  link: Scalars['String'];
  priority: Scalars['Int'];
  size: Scalars['Int'];
  type: Scalars['String'];
};

export type Query = {
  __typename?: 'Query';
  languages: Array<Scalars['String']>;
  point?: Maybe<Point>;
  user?: Maybe<User>;
};

export enum SearchField {
  Creator = 'creator',
  Description = 'description',
  ExtraShortDescription = 'extraShortDescription',
  Name = 'name',
  ShortDescription = 'shortDescription'
}

export type Service = {
  __typename?: 'Service';
  alias: Scalars['String'];
  bookLibrary: Array<Content>;
  categories?: Maybe<Array<Category>>;
  category?: Maybe<Category>;
  categoryByAlias?: Maybe<Category>;
  content?: Maybe<Content>;
  contents: Array<Content>;
  id: Scalars['ID'];
  languages: Array<Scalars['String']>;
  name: Scalars['String'];
  params: Array<MetaContentParam>;
  search: Array<Content>;
  searchByField: Array<Content>;
  tag?: Maybe<Tag>;
  tagByName?: Maybe<Tag>;
  tags?: Maybe<Array<Tag>>;
  totalContent: Scalars['Int'];
  totalContents: Scalars['Int'];
};


export type ServiceBookLibraryArgs = {
  limit?: Scalars['Int'];
  offset?: Scalars['Int'];
  sort?: Maybe<SortByParam>;
  type: LibraryType;
};


export type ServiceCategoryArgs = {
  id: Scalars['ID'];
};


export type ServiceCategoryByAliasArgs = {
  alias: Scalars['String'];
};


export type ServiceContentArgs = {
  id: Scalars['ID'];
};


export type ServiceContentsArgs = {
  filter?: Maybe<ContentFilter>;
  limit?: Scalars['Int'];
  offset?: Scalars['Int'];
  paramFilters?: Maybe<ParamFilters>;
  sort?: Maybe<SortByParam>;
};


export type ServiceParamsArgs = {
  name: Scalars['String'];
};


export type ServiceSearchArgs = {
  fields?: Array<SearchField>;
  lang?: Array<Scalars['String']>;
  limit?: Scalars['Int'];
  offset?: Scalars['Int'];
  query: Scalars['String'];
  sort?: Maybe<SortByParam>;
};


export type ServiceSearchByFieldArgs = {
  fields?: Maybe<Array<SearchField>>;
  lang?: Scalars['String'];
  limit?: Scalars['Int'];
  offset?: Scalars['Int'];
  query: Scalars['String'];
  sort?: Maybe<SortByParam>;
};


export type ServiceTagArgs = {
  id: Scalars['ID'];
};


export type ServiceTagByNameArgs = {
  name: Scalars['String'];
};


export type ServiceTotalContentsArgs = {
  filter?: Maybe<ContentFilter>;
  paramFilters?: Maybe<ParamFilters>;
  sort?: Maybe<SortByParam>;
};

export type SortByParam = {
  order: Order;
  paramName?: Maybe<Scalars['String']>;
};

export type Tag = {
  __typename?: 'Tag';
  contents: Array<Content>;
  description?: Maybe<Scalars['String']>;
  displayName: Scalars['String'];
  id: Scalars['ID'];
  localizations?: Maybe<Array<I18nTag>>;
  name: Scalars['String'];
  priority: Scalars['Int'];
  totalContent: Scalars['Int'];
  totalContents: Scalars['Int'];
};


export type TagContentsArgs = {
  categoryID?: Maybe<Scalars['ID']>;
  filter?: Maybe<ContentFilter>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  paramFilters?: Maybe<ParamFilters>;
  sort?: Maybe<SortByParam>;
};


export type TagLocalizationsArgs = {
  lang: Array<Scalars['String']>;
};


export type TagTotalContentsArgs = {
  categoryID?: Maybe<Scalars['ID']>;
  filter?: Maybe<ContentFilter>;
  paramFilters?: Maybe<ParamFilters>;
};

export type User = {
  __typename?: 'User';
  msisdn: Scalars['Int'];
  profileId: Scalars['Int'];
  sid: Scalars['String'];
  tariff: Scalars['Int'];
};

export type View = {
  __typename?: 'View';
  id: Scalars['ID'];
  isViewed: Scalars['Boolean'];
  total: Scalars['Int'];
};

export type ServiceQueryVariables = Exact<{
  lang: Array<Scalars['String']> | Scalars['String'];
}>;


export type ServiceQuery = (
  { __typename?: 'Query' }
  & { point?: Maybe<(
    { __typename?: 'Point' }
    & Pick<Point, 'id' | 'flowURL' | 'sskey' | 'verify'>
    & { service: (
      { __typename?: 'Service' }
      & ServiceFragment
    ) }
  )> }
);

export type CategoryByIdQueryVariables = Exact<{
  id: Scalars['ID'];
  lang: Array<Scalars['String']> | Scalars['String'];
  offset?: Scalars['Int'];
  limit?: Scalars['Int'];
}>;


export type CategoryByIdQuery = (
  { __typename?: 'Query' }
  & { point?: Maybe<(
    { __typename?: 'Point' }
    & Pick<Point, 'id'>
    & { service: (
      { __typename?: 'Service' }
      & Pick<Service, 'id'>
      & { category?: Maybe<(
        { __typename?: 'Category' }
        & CategoryFragment
      )> }
    ) }
  )> }
);

export type ContentByIdQueryVariables = Exact<{
  id: Scalars['ID'];
  lang: Array<Scalars['String']> | Scalars['String'];
}>;


export type ContentByIdQuery = (
  { __typename?: 'Query' }
  & { point?: Maybe<(
    { __typename?: 'Point' }
    & Pick<Point, 'id' | 'verify' | 'flowURL'>
    & { service: (
      { __typename?: 'Service' }
      & Pick<Service, 'id'>
      & { content?: Maybe<(
        { __typename?: 'Content' }
        & ContentFragment
      )> }
    ) }
  )> }
);

export type VerifyQueryVariables = Exact<{ [key: string]: never; }>;


export type VerifyQuery = (
  { __typename?: 'Query' }
  & { user?: Maybe<(
    { __typename?: 'User' }
    & UserFragment
  )>, point?: Maybe<(
    { __typename?: 'Point' }
    & Pick<Point, 'id' | 'verify' | 'sid'>
  )> }
);

export type ServiceFragment = (
  { __typename?: 'Service' }
  & Pick<Service, 'id'>
  & { categories?: Maybe<Array<(
    { __typename?: 'Category' }
    & ServiceCategoryFragment
  )>> }
);

export type UserFragment = (
  { __typename?: 'User' }
  & Pick<User, 'msisdn' | 'tariff' | 'sid' | 'profileId'>
);

export type ServiceCategoryFragment = (
  { __typename?: 'Category' }
  & Pick<Category, 'id' | 'alias' | 'name' | 'totalContent'>
  & { localizations?: Maybe<Array<(
    { __typename?: 'I18nCategory' }
    & CategoryLocalizationsFragment
  )>> }
);

export type CategoryFragment = (
  { __typename?: 'Category' }
  & Pick<Category, 'id' | 'alias' | 'name' | 'totalContent'>
  & { localizations?: Maybe<Array<(
    { __typename?: 'I18nCategory' }
    & CategoryLocalizationsFragment
  )>>, contents: Array<(
    { __typename?: 'Content' }
    & ContentFragment
  )> }
);

export type CategoryLocalizationsFragment = (
  { __typename?: 'I18nCategory' }
  & Pick<I18nCategory, 'id' | 'lang' | 'name'>
);

export type ContentFragment = (
  { __typename?: 'Content' }
  & Pick<Content, 'id' | 'description' | 'link' | 'type' | 'name'>
  & { category: (
    { __typename?: 'Category' }
    & Pick<Category, 'id'>
  ), metaContentParams?: Maybe<Array<(
    { __typename?: 'MetaContentParam' }
    & MetaContentParamFragment
  )>>, previews?: Maybe<Array<(
    { __typename?: 'Preview' }
    & PreviewFragment
  )>>, localizations?: Maybe<Array<(
    { __typename?: 'I18nContent' }
    & LocalizationFragment
  )>>, tags?: Maybe<Array<(
    { __typename?: 'Tag' }
    & TagFragment
  )>> }
);

export type MetaContentParamFragment = (
  { __typename?: 'MetaContentParam' }
  & Pick<MetaContentParam, 'id' | 'name' | 'value'>
  & { localizations?: Maybe<Array<(
    { __typename?: 'I18nMetaContentParam' }
    & Pick<I18nMetaContentParam, 'id' | 'value' | 'lang'>
  )>> }
);

export type PreviewFragment = (
  { __typename?: 'Preview' }
  & Pick<Preview, 'id' | 'link' | 'priority' | 'type'>
);

export type TagFragment = (
  { __typename?: 'Tag' }
  & Pick<Tag, 'id' | 'displayName' | 'name'>
);

export type LocalizationFragment = (
  { __typename?: 'I18nContent' }
  & Pick<I18nContent, 'id' | 'description' | 'link' | 'name'>
);

export const CategoryLocalizationsFragmentDoc = gql`
    fragment CategoryLocalizations on I18nCategory {
  id
  lang
  name
}
    `;
export const ServiceCategoryFragmentDoc = gql`
    fragment ServiceCategory on Category {
  id
  alias
  name
  totalContent
  localizations(lang: $lang) {
    ...CategoryLocalizations
  }
}
    ${CategoryLocalizationsFragmentDoc}`;
export const ServiceFragmentDoc = gql`
    fragment Service on Service {
  id
  categories {
    ...ServiceCategory
  }
}
    ${ServiceCategoryFragmentDoc}`;
export const UserFragmentDoc = gql`
    fragment User on User {
  msisdn
  tariff
  sid
  profileId
}
    `;
export const MetaContentParamFragmentDoc = gql`
    fragment MetaContentParam on MetaContentParam {
  id
  name
  value
  localizations(lang: $lang) {
    id
    value
    lang
  }
}
    `;
export const PreviewFragmentDoc = gql`
    fragment Preview on Preview {
  id
  link
  priority
  type
}
    `;
export const LocalizationFragmentDoc = gql`
    fragment Localization on I18nContent {
  id
  description
  link
  name
}
    `;
export const TagFragmentDoc = gql`
    fragment Tag on Tag {
  id
  displayName
  name
}
    `;
export const ContentFragmentDoc = gql`
    fragment Content on Content {
  id
  description
  link
  type
  category {
    id
  }
  metaContentParams {
    ...MetaContentParam
  }
  name
  previews {
    ...Preview
  }
  localizations(lang: $lang) {
    ...Localization
  }
  tags {
    ...Tag
  }
}
    ${MetaContentParamFragmentDoc}
${PreviewFragmentDoc}
${LocalizationFragmentDoc}
${TagFragmentDoc}`;
export const CategoryFragmentDoc = gql`
    fragment Category on Category {
  id
  alias
  name
  totalContent
  localizations(lang: $lang) {
    ...CategoryLocalizations
  }
  contents(offset: $offset, limit: $limit) {
    ...Content
  }
}
    ${CategoryLocalizationsFragmentDoc}
${ContentFragmentDoc}`;
export const ServiceDocument = gql`
    query Service($lang: [String!]!) {
  point {
    id
    flowURL
    service {
      ...Service
    }
    sskey
    verify
  }
}
    ${ServiceFragmentDoc}`;

/**
 * __useServiceQuery__
 *
 * To run a query within a React component, call `useServiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useServiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useServiceQuery({
 *   variables: {
 *      lang: // value for 'lang'
 *   },
 * });
 */
export function useServiceQuery(baseOptions: Apollo.QueryHookOptions<ServiceQuery, ServiceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ServiceQuery, ServiceQueryVariables>(ServiceDocument, options);
      }
export function useServiceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ServiceQuery, ServiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ServiceQuery, ServiceQueryVariables>(ServiceDocument, options);
        }
export type ServiceQueryHookResult = ReturnType<typeof useServiceQuery>;
export type ServiceLazyQueryHookResult = ReturnType<typeof useServiceLazyQuery>;
export type ServiceQueryResult = Apollo.QueryResult<ServiceQuery, ServiceQueryVariables>;
export const CategoryByIdDocument = gql`
    query CategoryById($id: ID!, $lang: [String!]!, $offset: Int! = 0, $limit: Int! = 8) {
  point {
    id
    service {
      id
      category(id: $id) {
        ...Category
      }
    }
  }
}
    ${CategoryFragmentDoc}`;

/**
 * __useCategoryByIdQuery__
 *
 * To run a query within a React component, call `useCategoryByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useCategoryByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCategoryByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *      lang: // value for 'lang'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useCategoryByIdQuery(baseOptions: Apollo.QueryHookOptions<CategoryByIdQuery, CategoryByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CategoryByIdQuery, CategoryByIdQueryVariables>(CategoryByIdDocument, options);
      }
export function useCategoryByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CategoryByIdQuery, CategoryByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CategoryByIdQuery, CategoryByIdQueryVariables>(CategoryByIdDocument, options);
        }
export type CategoryByIdQueryHookResult = ReturnType<typeof useCategoryByIdQuery>;
export type CategoryByIdLazyQueryHookResult = ReturnType<typeof useCategoryByIdLazyQuery>;
export type CategoryByIdQueryResult = Apollo.QueryResult<CategoryByIdQuery, CategoryByIdQueryVariables>;
export const ContentByIdDocument = gql`
    query ContentById($id: ID!, $lang: [String!]!) {
  point {
    id
    verify
    flowURL
    service {
      id
      content(id: $id) {
        ...Content
      }
    }
  }
}
    ${ContentFragmentDoc}`;

/**
 * __useContentByIdQuery__
 *
 * To run a query within a React component, call `useContentByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useContentByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContentByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *      lang: // value for 'lang'
 *   },
 * });
 */
export function useContentByIdQuery(baseOptions: Apollo.QueryHookOptions<ContentByIdQuery, ContentByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContentByIdQuery, ContentByIdQueryVariables>(ContentByIdDocument, options);
      }
export function useContentByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContentByIdQuery, ContentByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContentByIdQuery, ContentByIdQueryVariables>(ContentByIdDocument, options);
        }
export type ContentByIdQueryHookResult = ReturnType<typeof useContentByIdQuery>;
export type ContentByIdLazyQueryHookResult = ReturnType<typeof useContentByIdLazyQuery>;
export type ContentByIdQueryResult = Apollo.QueryResult<ContentByIdQuery, ContentByIdQueryVariables>;
export const VerifyDocument = gql`
    query Verify {
  user {
    ...User
  }
  point {
    id
    verify
    sid
  }
}
    ${UserFragmentDoc}`;

/**
 * __useVerifyQuery__
 *
 * To run a query within a React component, call `useVerifyQuery` and pass it any options that fit your needs.
 * When your component renders, `useVerifyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVerifyQuery({
 *   variables: {
 *   },
 * });
 */
export function useVerifyQuery(baseOptions?: Apollo.QueryHookOptions<VerifyQuery, VerifyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VerifyQuery, VerifyQueryVariables>(VerifyDocument, options);
      }
export function useVerifyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VerifyQuery, VerifyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VerifyQuery, VerifyQueryVariables>(VerifyDocument, options);
        }
export type VerifyQueryHookResult = ReturnType<typeof useVerifyQuery>;
export type VerifyLazyQueryHookResult = ReturnType<typeof useVerifyLazyQuery>;
export type VerifyQueryResult = Apollo.QueryResult<VerifyQuery, VerifyQueryVariables>;